import { useState } from "react";
import { motion } from "framer-motion";
import { Send, Mail } from "lucide-react";

const CAL_LINK = "https://cal.com/kalza-studio-hdho6x";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", website: "", service: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <main data-testid="contact-page">
      <section className="pt-32 pb-20 md:pb-28 bg-white min-h-screen">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
              <h1 className="mb-6">
                <span className="font-display text-5xl md:text-6xl lg:text-7xl text-[#1C1210] block">LET'S</span>
                <span className="font-accent text-5xl md:text-6xl lg:text-7xl text-[#BE123C] block">talk.</span>
              </h1>
              <p className="font-body text-base text-[#6B6560] leading-relaxed max-w-md mb-8">
                If something about the way your brand shows up online doesn't feel right, start here. Tell me a bit about your business and what's going on. I'll get back to you within 48 hours.
              </p>
              <div className="flex items-center gap-3 mb-4">
                <Mail size={16} className="text-[#BE123C]" />
                <a href="mailto:hello.kalza@gmail.com" className="font-body text-sm text-[#6B6560] hover:text-[#BE123C] transition-colors duration-300">hello.kalza@gmail.com</a>
              </div>
              <div className="mt-8 p-6 bg-[#F5F0EB] rounded-2xl">
                <p className="font-body text-sm text-[#6B6560] leading-relaxed mb-4">Want to talk first? Book a free 30-minute discovery call. I'll ask about your business, look at what's going on and tell you what I'd focus on first.</p>
                <a href={CAL_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-6 py-3 rounded-full hover:bg-[#9F1239] transition-colors duration-300">
                  BOOK A FREE CALL
                </a>
              </div>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.2 }}>
              <div className="space-y-5">
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Name</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] rounded-xl px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white" />
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Email</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] rounded-xl px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white" />
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Website URL <span className="text-[#6B6560]/50">(optional)</span></label>
                  <input type="url" name="website" value={form.website} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] rounded-xl px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white" />
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">What are you looking for?</label>
                  <select name="service" value={form.service} onChange={handleChange} className="w-full font-body text-sm border border-[#E8E3DE] rounded-xl px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white text-[#6B6560]">
                    <option value="">Select an option</option>
                    <option value="discovery">Free Discovery Call</option>
                    <option value="sprint">Brand Reality Check Sprint</option>
                    <option value="foundation">Brand Foundation</option>
                    <option value="visual">Brand Foundation & Visual Identity</option>
                    <option value="campaign">Campaign Concept</option>
                    <option value="unsure">Not sure yet</option>
                  </select>
                </div>
                <div>
                  <label className="font-body text-sm font-medium text-[#1C1210] mb-2 block">Tell me what's going on with your brand right now</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows={5} className="w-full font-body text-sm border border-[#E8E3DE] rounded-xl px-4 py-3 focus:outline-none focus:border-[#BE123C] transition-colors duration-300 bg-white resize-none" />
                </div>
                <button className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-8 py-4 rounded-full hover:bg-[#9F1239] transition-colors duration-300 w-full md:w-auto">
                  SEND YOUR MESSAGE <Send size={14} />
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>
  );
}
